import React, { useState } from 'react';
import { SERIES_COLORS, fmtNum } from './chartTheme';

// Donut breakdown with a center stat + legend.
//   slices: [{ label, value, color? }]
export default function Donut({
  slices = [],
  size = 168,
  thickness = 18,
  centerLabel = 'total',
  centerValue = null,
  formatValue = fmtNum,
}) {
  const [hot, setHot] = useState(null);
  const total = slices.reduce((a, s) => a + (s.value || 0), 0);
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  if (!total) return <div className="ck-empty">No data</div>;

  let acc = 0;
  const arcs = slices.filter((s) => s.value > 0).map((s, i) => {
    const frac = s.value / total;
    const arc = { ...s, i, frac, offset: acc };
    acc += frac;
    return arc;
  });

  return (
    <div className="ck-donut">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(var(--fg-rgb),0.06)" strokeWidth={thickness} />
          {arcs.map((a) => (
            <circle
              key={a.label}
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke={a.color || SERIES_COLORS[a.i]}
              strokeWidth={hot === a.label ? thickness + 3 : thickness}
              strokeDasharray={`${Math.max(a.frac * c - 2, 0.5)} ${c}`}
              strokeDashoffset={-a.offset * c}
              strokeLinecap="butt"
              className="ck-donut-arc"
              onMouseEnter={() => setHot(a.label)}
              onMouseLeave={() => setHot(null)}
            />
          ))}
        </g>
        <text x="50%" y="47%" textAnchor="middle" className="ck-donut-num">
          {hot != null
            ? formatValue(slices.find((s) => s.label === hot)?.value || 0)
            : formatValue(centerValue != null ? centerValue : total)}
        </text>
        <text x="50%" y="47%" dy="16" textAnchor="middle" className="ck-donut-cap">
          {hot != null ? hot : centerLabel}
        </text>
      </svg>
      <div className="ck-donut-legend">
        {arcs.map((a) => (
          <span
            key={a.label}
            className={hot === a.label ? 'hot' : ''}
            onMouseEnter={() => setHot(a.label)}
            onMouseLeave={() => setHot(null)}
          >
            <i style={{ background: a.color || SERIES_COLORS[a.i] }} />
            {a.label}
            <em>{Math.round(a.frac * 100)}%</em>
          </span>
        ))}
      </div>
    </div>
  );
}
